import { createApp } from 'vue';
import groupBy from "lodash/groupBy";
import TestApp from "JIX/components/typeindicator/TestApp.vue";

const stash = window.Stash["typeindicator/default"];

const catToDim = {
    E: "EI",
    I: "EI",
    S: "SN",
    N: "SN",
    T: "TF",
    F: "TF",
    J: "JP",
    P: "JP",
};

const questionsByDimension = groupBy(stash.questions, (q) =>
    catToDim[q[0].outcome]
);

const app = createApp(TestApp, { questions: questionsByDimension, resultUrl: stash.resultUrl });
app.mount('#app');
